export default __webpack_public_path__ + "static/RayStark-2fc5ca48fb9e9d25f2d2c852f27f480c.jpg";